<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Pedidos a Proyectar</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('generate', 'projections')"
            :to="{ name: 'ProjectionGenerate' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            >Cambiar campañas
          </router-link>
        </div>
      </div>
    </base-header>

    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div v-if="orders.length !== 0" class="col-md-8 col-12">
          <card body-classes="px-0 pb-0" class="no-border-card">
            <template slot="header">
              <h3 class="mb-0">Previsualización de proyecciones</h3>
            </template>

            <div class="row px-5 mb-3">
              <div class="col-12 col-md-6 col-lg-4">
                <h3>
                  Campaña Actual: <span class="font-weight-normal">{{ currentCampaignName }}</span>
                </h3>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <h3>
                  Campaña Previa: <span class="font-weight-normal">{{ previousCampaignName }}</span>
                </h3>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <h3>
                  Distribuidor: <span class="font-weight-normal">{{ distributorName }}</span>
                </h3>
              </div>
            </div>

            <preview-projections-table ref="previewTable" :orders="orders" />

            <div slot="footer" class="row">
              <div class="col-12 text-right">
                <router-link
                  v-if="$can('generate', 'projections')"
                  :to="{ name: 'ProjectionGenerate' }"
                  class="btn base-button btn-neutral px-5"
                >
                  Cancelar
                </router-link>

                <base-button type="primary" class="px-3" @click="generateProjections">
                  Generar proyecciones
                </base-button>
              </div>
            </div>
          </card>
        </div>
        <div v-else class="col-md-8">
          <span>El distributor no posee pedidos a proyectar</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Cards/Card';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PreviewProjectionsTable from './PreviewProjectionsTable';
import swal from 'sweetalert2';

export default {
  components: {
    RouteBreadCrumb,
    PreviewProjectionsTable,
    Card,
  },

  data() {
    return {
      orders: [],
      isDataLoaded: false,
      currentCampaignName: '',
      previousCampaignName: '',
      distributorName: '',
    };
  },

  created() {
    this.fetchOrdersData();
    this.fetchFilterData();
  },

  methods: {
    fetchOrdersData() {
      this.$services
        .resource('projection_generate')
        .get(this.$route.params)
        .then((res) => res.data.data)
        .then(({ orders }) => {
          this.orders = orders;
          this.isDataLoaded = true;
        })
        .catch((err) => {
          swal({
            title: `Error`,
            text: err.response.data,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning',
          }).then(() => {
            this.$router.push({ name: 'ProjectionGenerate' });
          });
        });
    },

    generateProjections() {
      const ordersId = this.$refs.previewTable.getSelectedItems();
      const params = {
        ordersId: ordersId,
        previousCampaign: this.$route.params.previous_campaign,
        currentCampaign: this.$route.params.current_campaign,
        distributor: this.$route.params.distributor,
      };
      this.$services
        .resource('projection_generate')
        .create(params)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'Las proyecciones fueron generadas con éxito.',
            type: 'success',
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: 'Ir al listado',
            confirmButtonClass: 'btn btn-secondary',
          }).then(() => {
            this.$router.push({ name: 'ProjectionsList' });
          });
        })
        .catch((error) => {
          swal({
            title: `Atención`,
            text: error.response.data,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning',
          });
        });
    },

    async fetchFilterData() {
      const currentCampaign = await this.$services
        .resource('campaigns')
        .show(this.$route.params.current_campaign)
        .then((res) => res.data.data);
      this.currentCampaignName = currentCampaign.name;
      const previousCampaign = await this.$services
        .resource('campaigns')
        .show(this.$route.params.previous_campaign)
        .then((res) => res.data.data);
      this.previousCampaignName = previousCampaign.name;
      const distributor = await this.$services
        .resource('distributors')
        .show(this.$route.params.distributor)
        .then((res) => res.data.data);
      this.distributorName = distributor.name;
    },
  },
};
</script>

<style lang="scss" scoped></style>
